<template>
    <div class="fill-height">

        <v-progress-linear
                :active="inLoading"
                :indeterminate="inLoading"
                absolute
                color="deep-purple-accent-4"
        ></v-progress-linear>

        <v-snackbar color="error" location="top" v-model="snackbarError" :timeout="15000">
            <span>{{ message }}</span>
            <template v-slot:actions>
                <v-btn variant="text" @click="snackbarError = false">{{ $t('close') }}</v-btn>
            </template>
        </v-snackbar>

        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-card class="elevation-12">

                        <v-card-text>
                            <v-form ref="form">

                                <v-text-field
                                        ref="password"
                                        :label="$t('password')"
                                        name="password"
                                        type="password"
                                        variant="outlined"
                                        :rules="passwordRules"
                                        required
                                        counter
                                        :append-icon="'mdi-eye-off'"
                                        v-model="password"
                                ></v-text-field>

                                <v-text-field
                                        ref="confirmPassword"
                                        :label="$t('confirmPassword')"
                                        name="confirmPassword"
                                        type="password"
                                        variant="outlined"
                                        :rules="confirmPasswordRules"
                                        required
                                        :append-icon="'mdi-eye-off'"
                                        v-model="confirmPassword"
                                ></v-text-field>

                                <v-btn color="success" style="min-height: 50px" block
                                       @click="updatePassword()" :disabled='inProgress || inLoading'>
                                    {{ $t('updatePassword') }}
                                </v-btn>

                            </v-form>
                        </v-card-text>
                    </v-card>

                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>

    import api from './backend-api'
    import { useI18n } from 'vue-i18n'
    import { useStore } from 'vuex'

    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/;

    export default {
        name: "PasswordUpdate",
        setup() {
            const { t } = useI18n();
            const store = useStore();
            return { t, store };
        },
        data() {
            return {
                password: '',
                confirmPassword: '',
                message: '',
                snackbarError: false,
                inProgress: false,
                inLoading: false,
                code: '',
                passwordRules: [
                    v => !!v || this.t('passwordRequired'),
                    v => passwordPattern.test(v) || this.t('passwordFormat'),
                ],
                confirmPasswordRules: [
                    v => !!v || this.t('passwordRequired'),
                    v => v === this.password || this.t('passwordMatch'),
                ],
            }
        },
        methods: {
            async updatePassword() {
                this.inProgress = true;
                this.inLoading = true;
                this.code = this.$route.params.code;
                const { valid } = await this.$refs.form.validate();
                if (!valid) {
                    this.inProgress = false;
                    this.inLoading = false;
                } else {
                    api.updatePassword(this.code, this.confirmPassword)
                        .then(response => {
                            if (response.data.success) {
                                this.store.commit('setMessage', response.data.message);
                                this.$router.push('/login').catch(error => {console.log(error);});
                            } else {
                                this.inProgress = false;
                                this.inLoading = false;
                                this.message = response.data.message;
                                this.snackbarError = true;
                            }
                        })
                        .catch(error => {
                            console.log(error);
                            this.message = this.t('connectionLost');
                            this.snackbarError = true;
                            this.inProgress = false;
                            this.inLoading = false;
                        })
                }
            }
        }
    }
</script>

<style scoped>

</style>